import React from 'react';
import Layout from '../../components/Layout';
import Categories from './Categories';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import NotFound from '../../components/NotFound/NotFound';
import { getCategory } from '../../actions/category/getCategory';
import { decode } from '../../helpers/queryEncryption';

async function action({ params, store, query }) {
    const title = store.getState().siteSettings?.data?.siteTitle
    const description = store.getState().siteSettings?.data?.metaDescription;
    const categories = store.getState().categories?.data;
    let isAuthenticated = store.getState().runtime.isAuthenticated;

    !categories && store.dispatch(getCategory());
    let categoryValue;
    if ("type" in query && encodeURI(query?.type)) {
        categoryValue = query?.type
    }
    if (categoryValue !== 'all') {
        try {
            categoryValue = decodeURIComponent(decode(query?.type));
            categoryValue = categoryValue === '' ? query?.type : categoryValue;
        } catch (error) {
            return;
        }
    }

    if (!query?.type || Number(query?.type)) {
        return {
            title,
            component: (
                <Layout>
                    <NotFound title={'Page Not Found'} />
                </Layout>
            ),
        };
    }

    return {
        title,
        description,
        component: (
            <Layout>
                <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
                    {isAuthenticated && <SubNavBar />}
                    <Categories categoryValue={categoryValue} />
                </div>
            </Layout>
        ),
    };
}

export default action;


